<template>
  <div class="course-info">
    <div class="course-head">
      <div class="course-title">{{ courseInfo.courseName }}</div>
      <div class="course-rate">
        <el-rate
          v-model="courseInfo.avgscore"
          disabled
          text-color="#ff9900"
          score-template="{value}"
        >
        </el-rate>
        <span style="height: 100%; width: 1px">|</span>
        <span>{{ courseInfo.viewtimes }} Views</span>
      </div>
    </div>
    <div class="top">
      <div class="max-width-box">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/course' }"
            >Courses</el-breadcrumb-item
          >
          <el-breadcrumb-item
            v-if="navTree"
            :to="{
              path: '/course',
              query: { courseType: courseInfo.FathercourseType },
            }"
          >
            {{
              navTree[0].children.filter(
                (a) => a.id === courseInfo.FathercourseType
              )[0]
                ? navTree[0].children.filter(
                    (a) => a.id === courseInfo.FathercourseType
                  )[0].name
                : ""
            }}
          </el-breadcrumb-item>
          <el-breadcrumb-item>{{ courseInfo.courseName }}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="course-title">{{ courseInfo.courseName }}</div>
        <div class="course-rate">
          <el-rate
            v-model="courseInfo.avgscore"
            disabled
            text-color="#ff9900"
            score-template="{value}"
          >
          </el-rate>
          <span style="height: 100%; width: 1px">|</span>
          <span>{{ courseInfo.viewtimes }} Views</span>
        </div>
        <div class="course-teacher">
          <img
            class="course-teacher-avatar"
            :src="
              courseInfo.covey_user
                ? courseInfo.covey_user.photo
                : defaultAvatar
            "
          />
          <span>{{
            courseInfo.covey_user ? courseInfo.covey_user.realname : "UNKNOWN"
          }}</span>
          <!-- <div class="course-teacher-level">
                        <img :src="require('@/assets/icon/drhat.png')">Top teachers
                    </div> -->
        </div>
      </div>
    </div>
    <div class="middle max-width-box">
      <div class="left">
        <div class="course-info-box">
          <div class="course-info-title">Course Details</div>
          <div class="course-info-content">{{ courseInfo.courseDesc }}</div>
          <!-- <div class="course-info-more">More</div> -->
        </div>

        <div class="course-info-box">
          <div class="course-info-title">
            About
            {{
              courseInfo.covey_user ? courseInfo.covey_user.realname : "UNKNOWN"
            }}
          </div>
          <div class="course-info-teacher">
            <img
              class="teacher-avatar"
              :src="
                courseInfo.covey_user
                  ? courseInfo.covey_user.photo
                  : defaultAvatar
              "
            />
            <div class="teacher-1">
              <div>
                {{
                  courseInfo.covey_user
                    ? courseInfo.covey_user.realname
                    : "UNKNOWN"
                }}
              </div>
              <div>The University of Science and Technology</div>
              <div class="teacher-rate">
                <span>{{
                  courseInfo.covey_user ? courseInfo.covey_user.avgscore : 0
                }}</span>
                <el-rate
                  :colors="['#F48C06', '#F48C06', '#F48C06']"
                  v-model="courseInfo.covey_user.avgscore"
                  disabled
                  score-template="{value}"
                >
                </el-rate>
              </div>
            </div>
            <div class="teacher-2">
              <div>
                <img :src="require('@/assets/icon/medal.png')" />
                <span
                  >{{
                    courseInfo.covey_user
                      ? courseInfo.covey_user.evaluationtimes
                      : 0
                  }}
                  evaluates</span
                >
              </div>
              <div>
                <img :src="require('@/assets/icon/student.png')" />
                <span
                  >{{
                    courseInfo.covey_user
                      ? courseInfo.covey_user.studentnums
                      : 0
                  }}
                  students</span
                >
              </div>
              <div>
                <img :src="require('@/assets/icon/play.png')" />
                <span
                  >{{
                    courseInfo.covey_user ? courseInfo.covey_user.coursenums : 0
                  }}
                  courses</span
                >
              </div>
            </div>
          </div>
          <div class="course-info-content">
            {{ courseInfo.covey_user.desc }}
          </div>
          <!-- <div class="course-info-more">More</div> -->
        </div>

        <div class="course-info-box">
          <div class="course-info-title">
            More Services By
            {{
              courseInfo.covey_user ? courseInfo.covey_user.realname : "UNKNOWN"
            }}
          </div>
          <div class="recommendCourses-container">
            <!-- <div class="prev-box"></div> -->
            <el-button
              class="prev"
              icon="el-icon-arrow-left"
              @click="prevCourse"
            ></el-button>
            <RecommendCourses
              class="courses-in-courseinfo"
              :courseList="realDisplayCourseList"
            ></RecommendCourses>

            <el-button
              class="next"
              icon="el-icon-arrow-right"
              @click="nextCourse"
            ></el-button>
            <!-- <div class="next-box"></div> -->
          </div>
        </div>

        <div
          class="course-info-box"
          style="
            padding-bottom: 32px;
            border-bottom: 1px solid rgba(126, 128, 136, 0.16);
          "
        >
          <div class="course-info-title">Feedback</div>
          <div class="course-info-teacher-rate">
            <div class="rate-box">
              <div class="teacher-rate-num">
                {{ courseInfo.avgscore.toFixed(1) }}
              </div>
              <el-rate
                :colors="['#F48C06', '#F48C06', '#F48C06']"
                v-model="courseInfo.avgscore"
                disabled
                score-template="{value}"
              >
              </el-rate>
              <div style="color: #7e8088">
                {{ courseInfo.evaluationtimes }} Reviews
              </div>
            </div>

            <div class="rates-box">
              <div
                class="rates-item"
                v-for="(item, index) in courseCommentRate"
                :key="index"
              >
                <div class="rates-item-num">{{ 5 - index }} stars</div>
                <el-progress
                  :percentage="parseFloat(item.percent)"
                  :stroke-width="8"
                ></el-progress>
              </div>
            </div>
          </div>
        </div>

        <Review :courseId="courseId"></Review>
      </div>

      <div class="right">
        <div class="course-info-right">
          <div class="course-info-img">
            <el-carousel
              trigger="click"
              height="200px"
              :autoplay="false"
              indicator-position="none"
              :initial-index="1"
            >
              <el-carousel-item
                v-for="(img, index) in courseInfo.courseImg"
                :key="index"
                :style="{ 'background-image': 'url(' + img + ')' }"
              >
              </el-carousel-item>
              <el-carousel-item v-if="courseInfo.courseVideo">
                <video-player
                  class="video-player-box"
                  ref="videoPlayer"
                  :options="videoOption"
                  :playsinline="true"
                  customEventName="customstatechangedeventname"
                >
                </video-player>
              </el-carousel-item>
            </el-carousel>

            <!-- <img :src="courseInfo.courseImg?courseInfo.courseImg[0]:''" /> -->
            <div class="play-button"></div>
          </div>
          <div class="course-info-right-content">
            <div style="font-size: 36px">
              C${{
                (coursePrice[0] ? coursePrice[0].price / 100 : 0).toFixed(2)
              }}
            </div>
            <div class="course-price-box" v-if="coursePrice.length > 0">
              <div
                class="course-price"
                v-for="(item, index) in coursePrice"
                :key="index"
              >
                <img :src="require('@/assets/icon/yes.png')" />
                {{ item.book_amount }} Lesson / C$
                {{ (item.price / 100).toFixed(2) }} Session (1 hour)
              </div>
            </div>
            <div class="course-price-box" v-else>
              Contact your tutor for a big discount !
            </div>
            <el-button
              class="my-button"
              :class="{
                'is-me':
                  userInfo.id === courseInfo.teacherID ||
                  userInfo.usertype === 1,
              }"
              @click="gotoBookaClass(courseInfo)"
            >
              Buy now
            </el-button>
            <el-button
              class="el-icon-chat-dot-round my-chat-button"
              :class="{ 'is-me': userInfo.id === courseInfo.teacherID }"
              @click="contactPeople(courseInfo.covey_user.id)"
            >
              Contact Seller
            </el-button>
            <!-- <div
              class="to-chat"
              @click="contactPeople(courseInfo.covey_user.id)"
            >
              <i class="el-icon-chat-dot-round"></i>
            </div> -->
          </div>
          <!-- <div
            :class="{ 'is-me': userInfo.id === courseInfo.teacherID }"
            class="to-chat"
            @click="contactPeople(courseInfo.covey_user.id)"
          >
            <i class="el-icon-chat-dot-round"></i>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Review from "./Review.vue";
import TeacherDisplayboard from "./TeacherDisplayboard.vue";
import RecommendCourses from "./RecommendCourses.vue";
import { mapState } from "vuex";
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
export default {
  watch: {
    "$route.query": function (newVal, oldVal) {
      this.initPage();
    },
  },
  computed: {
    ...mapState({
      xToken: (state) => state.app.token,
      userInfo: (state) => state.app.userInfo,
      defaultAvatar: (state) => state.app.defaultAvatar,
      navTree: (state) => state.menu.navTree,
    }),
  },
  components: {
    Review,
    TeacherDisplayboard,
    RecommendCourses,
    videoPlayer,
  },
  mounted() {
    this.initPage();
  },
  data() {
    return {
      courseId: "",
      courseInfo: {
        avgscore: 0,
        covey_user: {
          avgscore: 0,
        },
      },
      courseCommentRate: [],
      coursePrice: [],
      teachersCourseList: [],
      realDisplayCourseList: [],
      displayIndex: 0,
      videoUrl: "",
      videoOption: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", // 类型
            src: "", // url地址
          },
        ],
        poster: "", // 封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true, // 是否显示全屏按钮
        },
      },
    };
  },
  methods: {
    initPage() {
      this.courseId = this.$route.query.courseId || "";

      this.getCourseDetail().then(() => {
        this.getCourseListbyTeachaer(this.courseInfo.covey_user.id);
      });
      this.getCoursePrice();
      this.getCourseCommentRate();
    },
    async getCourseDetail() {
      await this.$api.courseApi
        .getCoursesDetail({ courseId: this.courseId })
        .then((res) => {
          if (res.status === "0") {
            res.data.courseImg = JSON.parse(res.data.courseImg);
            this.courseInfo = res.data;
            this.courseInfo.covey_user.price = this.courseInfo.price;
            this.videoOption.sources[0].src = this.courseInfo.courseVideo;
          } else {
            this.$message.error("Error!" + res.message);
          }
        });
    },
    getCoursePrice() {
      this.$api.courseApi
        .getCoursePrice({ courseId: this.courseId })
        .then((res) => {
          if (res.status === "0") {
            this.coursePrice = res.data;
          } else {
            this.$message.error("Error!" + res.message);
          }
        });
    },
    gotoBookaClass(item) {
      if (!this.xToken) {
        this.$store.commit("SET_LOGIN_DIALOG", true); //关闭登录dialog
        return;
      }
      this.$router.push({
        path: "/page/bookacourse",
        query: {
          teacherId: item.teacherID,
          courseId: item.id,
        },
      });
    },
    getCourseCommentRate() {
      this.$api.courseApi
        .getCourseCommentRate({ courseId: this.courseId })
        .then((res) => {
          if (res.status === "0") {
            this.courseCommentRate = res.data.reverse();
          } else {
            this.$message.error("Error!" + res.message);
          }
        });
    },
    contactPeople(id) {
      if (!this.xToken) {
        this.$store.commit("SET_LOGIN_DIALOG", true); //关闭登录dialog
        return;
      }
      if (id === this.userInfo.id) {
        this.$message.error("Can't talk to yourself!");
        return;
      }
      let routeData = this.$router.resolve({
        path: "/chat?contactId=" + id,
      });
      window.open(routeData.href, "_blank");
    },

    getCourseListbyTeachaer(teacherId) {
      this.$api.courseApi
        .getDetaiTeacherCourses({ teacherId: teacherId, id: this.courseId })
        .then((res) => {
          if (res.status === "0") {
            res.data.rows.forEach(
              (item) => (item.courseImg = JSON.parse(item.courseImg))
            );
            this.teachersCourseList = res.data.rows;
            this.realDisplayCourseList = this.teachersCourseList.slice(0, 3);
          }
        });
    },
    prevCourse() {
      this.displayIndex -= 1;
      this.activeCourse();
    },
    nextCourse() {
      this.displayIndex += 1;
      this.activeCourse();
    },
    activeCourse() {
      if (this.displayIndex < 0) {
        this.displayIndex = 0;
        return;
      }
      if (this.displayIndex * 3 >= this.teachersCourseList.length) {
        this.displayIndex = parseInt(this.teachersCourseList.length / 3);
        return;
      }
      this.realDisplayCourseList = this.teachersCourseList.slice(
        this.displayIndex * 3,
        this.displayIndex * 3 + 3
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.course-info {
  width: 100%;
  // padding: vw(48) vw(170);
  // box-sizing: border-box;
  // display: flex;
  // align-items: flex-start;
  transition: 0.2s;
  .is-me {
    color: #7e8088;
    background: #b7b2ae !important;
    pointer-events: none;
    cursor: not-allowed;
  }
  .course-head {
    display: none;
    width: 100%;
    position: fixed;
    padding: 11px 160px;
    background: linear-gradient(270deg, #175fa8 0%, #0a3a76 100%);
    .course-title {
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 30px;
    }
    .course-rate {
      height: 20px;
      margin-top: 8px;
      font-size: 14px;
      .el-rate {
        display: inline;
      }
      span {
        color: #ffffff;
        margin-left: 16px;
        vertical-align: middle;
      }
    }
  }
  .top {
    // padding: 100px 160px 56px 160px;
    padding: 100px 24px 40px;
    background: linear-gradient(270deg, #175fa8 0%, #0a3a76 100%);
    color: #fff;
    .el-breadcrumb {
      /deep/.el-breadcrumb__inner {
        color: #fff;
      }
    }
    .course-title {
      font-size: 36px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 30px;
      margin-top: 32px;
    }
    .course-rate {
      margin-top: 32px;
      font-size: 14px;
      .el-rate {
        display: inline;
      }
      span {
        margin-left: 16px;
        vertical-align: middle;
      }
    }
    .course-teacher {
      margin-top: 32px;
      display: flex;
      align-items: center;
      .course-teacher-avatar {
        border-radius: 50%;
        width: 36px;
        height: 36px;
      }
      span {
        margin-left: 8px;
        font-size: 14px;
        align-self: center;
      }
      .course-teacher-level {
        padding: 2px 8px;
        height: 24px;
        background: #eceb98;
        border-radius: 2px;
        margin-left: 24px;
        color: #181d2c;
        font-size: 14px;
        img {
          margin-right: 4px;
          width: 16px;
          height: 16px;
          vertical-align: middle;
        }
      }
    }
  }
  .middle {
    // padding: 0 160px 56px 160px;
    padding: 0 24px;
    display: flex;
    position: relative;
  }
  .recommendCourses-container {
    margin-top: 16px;
    display: flex;
    // align-items: center;
    justify-content: space-between;
    position: relative;
    /deep/.teacher-avatar-box {
      display: none !important;
    }
    /deep/.describe {
      margin-top: 20px;
    }
    &:hover {
      .prev {
        left: 2px;
      }
      .next {
        right: 2px;
      }
      .el-button {
        display: block;
        z-index: 5;
        height: 56px;
        box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.18);
        transform: translateX(0);
        opacity: 1;
      }
    }
    .prev {
      left: 0;
      transform: translateX(-10px);
    }
    .next {
      right: 0;
      transform: translateX(10px);
    }
    .el-button {
      color: #f48c06;
      transition: 0.5s;
      top: calc(50% - 28px);
      z-index: 4;
      width: 56px;
      height: 56px;
      padding: 0;
      border-radius: 50%;
      position: absolute;
      border: none;
      box-shadow: none;
      opacity: 0;

      &:hover {
        transform: scale(1.04);
      }
    }
    .courses-in-courseinfo {
      padding: 0;
      margin: 0 !important;
      /deep/.course-list-box {
        grid-template-columns: repeat(3, 1fr) !important;
        grid-gap: 16px;
      }
    }
  }
  .left {
    // position: -webkit-sticky; /* Safari */
    // position: sticky;
    // top: vw(88);
    // flex:2.45;
    // margin-right: vw(32);
    padding-bottom: 32px;
    width: 65%;
    .course-info-box {
      margin-top: 48px;

      .course-info-title {
        font-size: 24px;
        font-weight: 600;
        color: #181d2c;
        line-height: 24px;
      }
      .course-info-content {
        white-space: pre-line;
        font-size: 14px;
        font-weight: 400;
        color: #181d2c;
        line-height: 24px;
        margin-top: 24px;
        &:hover {
          // background: rgb(231, 231, 231);
        }
      }
      .course-info-more {
        cursor: pointer;
        font-size: 14px;
        font-weight: 600;
        color: #f48c06;
        line-height: 24px;
        margin-top: 12px;
      }
      .course-info-teacher {
        display: flex;
        align-items: center;
        margin-top: 24px;
        line-height: 24px;
        .teacher-avatar {
          width: 112px;
          height: 112px;
          border-radius: 50%;
        }
        .teacher-1 {
          margin-left: 24px;
          color: #181d2c;
          font-size: 14px;
          div:nth-child(1) {
            font-weight: 600;
          }
          div:nth-child(2) {
            font-weight: 500;
          }
          .teacher-rate {
            color: #f48c06;
            .el-rate {
              display: inline-block;
            }
            span {
              vertical-align: middle;
              margin-right: 8px;
              color: #f48c06;
            }
          }
        }
        .teacher-2 {
          margin-left: 24px;
          img {
            vertical-align: middle;
            width: 16px;
            height: 16px;
          }
          span {
            margin-left: 8px;
            line-height: 24px;
            font-size: 14px;
          }
        }
      }
      .course-info-teacher-rate {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-top: 8px;

        .rate-box {
          width: auto;
          text-align: center;
          .teacher-rate-num {
            height: 67px;
            font-size: 48px;
            font-weight: 500;
            color: #181d2c;
            line-height: 67px;
          }
        }
        .rates-box {
          width: calc(100% - 199px);
          .rates-item {
            width: 100%;
            margin: 8px 0;
            display: flex;
            .rates-item-num {
              width: 64px;
              font-size: 14px;
              color: #181d2c;
            }
            /deep/.el-progress {
              width: 100%;
              .el-progress-bar {
                padding-right: 70px;
                margin-right: -70px;
                width: 100%;
                .el-progress-bar__outer {
                  height: 8px;
                  border-radius: 0;
                  background: rgba(126, 128, 136, 0.16);
                }
                .el-progress-bar__inner {
                  background: #f48c06;
                  border-radius: 0;
                }
              }
              .el-progress__text {
                font-size: 14px !important;
                color: #181d2c;
              }
            }
          }
        }
      }
    }
  }
  .right {
    margin-left: 32px;
    // position: -webkit-sticky; /* Safari */
    // position: sticky;
    // top: 0px;
    z-index: 6;
    .video-player-box {
      width: 100%;
      height: 100%;
      /deep/.video-js .vjs-big-play-button {
        width: 1.5em;
        border-radius: 50%;
        top: calc(50% - 0.75em);
        left: calc(50% - 0.75em);
      }
    }
    .course-info-right {
      position: -webkit-sticky; /* Safari */
      position: sticky;
      margin-top: -180px;
      top: 140px;
      width: 340px;
      background: #ffffff;
      box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
      border-radius: 1px;
      .course-info-img {
        position: relative;

        /deep/.el-carousel {
          overflow: hidden;
          // height: 200px;
          .el-carousel__item {
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 100%;
            transition: 0.5s;
            &:hover {
              background-size: 120%;
            }
          }
        }
        img {
          width: 100%;
          height: 200px;
        }
        .play-button {
          cursor: pointer;
          position: absolute;
          top: calc(50% - 32px);
          left: calc(50% - 32px);
          width: 64px;
          height: 64px;
          background: url("../../../assets/icon/play_2x.png");
        }
      }
      .course-price-box {
        margin-top: 28px;
        font-size: 14px;
        color: #181d2c;
        line-height: 20px;

        .course-price {
          margin-bottom: 16px;
          img {
            vertical-align: middle;
            margin-right: 12px;
          }
        }
      }
      .course-info-right-content {
        padding: 26px 32px 32px 32px;
      }
    }
    .to-chat {
      position: absolute;
      margin-top: 20px;
      cursor: pointer;
      padding: 16px;
      background: #fff;
      display: inline-block;
      box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
      border-radius: 50%;
      i {
        font-size: 32px;
      }
    }
  }
  .my-button {
    width: 100%;
    height: 48px;
    background: #f48c06;
    border-radius: 4px;
    font-size: 14px;
    margin-top: 16px;
    color: #ffffff;
    border: none;
  }
  .my-chat-button {
    width: 100%;
    height: 48px;
    border-radius: 4px;
    font-size: 14px;
    margin-top: 16px;
    margin-left: 0 !important;
    &:hover {
      color: #f48c06;
      border-color: #f8d19e;
      background-color: #ffffff;
    }
  }
}
</style>
